function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "LSE");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Artboard",
  transform: "translate(-286.000000, -145.000000)",
  fill: "#FFFFFF"
}, React.createElement("g", {
  id: "LSE",
  transform: "translate(286.000000, 145.000000)"
}, React.createElement("path", {
  d: "M61.5,0.5 C27.8,0.5 0.5,27.8 0.5,61.5 C0.5,95.2 27.8,122.5 61.5,122.5 C95.2,122.5 122.5,95.2 122.5,61.5 C122.5,27.8 95.2,0.5 61.5,0.5 Z M90.8,88.8 L61.5,88.8 L32.2,88.8 C28.4,88.8 25.3,85.8 25.3,82.1 C25.3,81.1 25.5,80.1 26,79.2 C30.7,69.8 38.7,56.4 45.7,44.6 L45.8,44.5 C49.3,38.6 52.9,32.5 55.5,28 C56.8,25.7 59,24.4 61.6,24.4 C64.1,24.4 66.4,25.7 67.7,28 C70.2,32.4 73.6,38.2 77.3,44.4 L77.4,44.5 C84.4,56.3 92.3,69.6 97.1,79.1 L97.2,79.3 C97.7,80.2 97.9,81.2 97.9,82.2 C97.7,85.8 94.6,88.8 90.8,88.8 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M73.8,46.3 C70.1,40.1 66.6,34.3 64.1,29.7 C63.6,28.8 62.6,28.2 61.5,28.2 C60.4,28.2 59.4,28.8 58.9,29.7 C56.4,34.2 52.9,40.1 49.2,46.3 C42.2,58.1 34.3,71.5 29.6,80.8 C29.4,81.2 29.3,81.6 29.3,82 C29.3,83.6 30.6,84.8 32.2,84.8 L90.9,84.8 C92.5,84.8 93.8,83.5 93.8,82 C93.8,81.6 93.7,81.2 93.5,80.8 C88.7,71.5 80.8,58.1 73.8,46.3 Z M61.5,79.4 C60.2,79.4 59.1,78.4 59.1,77.1 C59.1,75.8 60.2,74.8 61.5,74.8 C62.8,74.8 63.9,75.8 63.9,77.1 C63.9,78.4 62.8,79.4 61.5,79.4 Z M63.9,68.9 C63.9,70 62.8,70.8 61.5,70.8 C60.1,70.8 59.1,69.9 59.1,68.9 L59.1,40.1 C59.1,39 60.2,38.2 61.5,38.2 C62.9,38.2 63.9,39.1 63.9,40.1 L63.9,68.9 Z",
  id: "Shape"
}))));

var SvgIconLseWarning = function SvgIconLseWarning(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "123px",
    height: "123px",
    viewBox: "0 0 123 123",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconLseWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-lse-warning.aac1cc2b.svg";
export { ForwardRef as ReactComponent };